/* eslint-disable import/first */
import React, { Component } from "react";
import { Formik } from "formik";
import { Route, withRouter } from "react-router-dom";
import {
	Navbar,
	Nav,
	NavDropdown,
	Form,
	Button,
	Row,
	Col,
	Jumbotron,
	Table,
	Tr,
	Td,
	Pagination,
} from "react-bootstrap";
import * as config from "config/config";
import NavPublic from "components/nav/NavPublic";
import DatePickerField from "helpers/datePickerField";

/*CSS*/

class ModifyAdresse extends Component {
	constructor() {
		super();
		this.state = {
			adresses: [],
		};
	}
	componentDidMount() {
		config
			.apiFetch(
				config.Api_Url +
					"/adresse/getAdresseById/" +
					this.props.match.params.a_id
			)
			.then((response) => response.json())
			.then((data) => {
				this.setState({
					adresses: data["data"][0],
				});
			});
	}
	render() {
		return (
			<div>
				<NavPublic />
				<div className="container">
					<Row className="justify-content-center">
						<Col md={6}>
							<h1>Modifier une adresse</h1>
							<Formik
								initialValues={this.state.adresses}
								enableReinitialize
								onSubmit={(values, { setSubmitting }) => {
									config
										.apiFetch(config.Api_Url + "/update/updateAdresseById", {
											method: "POST",
											body: JSON.stringify({
												telephonedest: values.telephonedest,
												villedest: values.villedest,
												codepostaldest: values.codepostaldest,
												adressedest: values.adressedest.replace(/'/g, "\\'"),
												prenomdest: values.prenomdest,
												nomdest: values.nomdest,
												codesociete: values.codesociete,
												a_id: this.props.match.params.a_id,
											}),
											headers: {
												"Content-Type": "application/json",
											},
										})
										.then((response) => response.json())
										.then((data) => {
											window.location.reload();
										});
								}}
							>
								{({
									values,
									errors,
									touched,
									handleChange,
									handleBlur,
									handleSubmit,
									isSubmitting,
									/* and other goodies */
								}) => (
									<Form onSubmit={handleSubmit}>
										<Form.Label>Code société: (Ex: MBC44A) :</Form.Label>
										<Form.Control
											type="text"
											aria-describedby="inputGroupPrepend"
											name="codesociete"
											value={values.codesociete || ""}
											onChange={handleChange}
										/>

										<Form.Label className="">Nom ou société :</Form.Label>
										<Form.Control
											type="text"
											aria-describedby="inputGroupPrepend"
											name="nomdest"
											value={values.nomdest || ""}
											onChange={handleChange}
										/>
										<Form.Label className="">Prénom :</Form.Label>
										<Form.Control
											type="text"
											aria-describedby="inputGroupPrepend"
											name="prenomdest"
											value={values.prenomdest || ""}
											onChange={handleChange}
										/>

										<Form.Label className="required">Adresse :</Form.Label>
										<Form.Control
											required
											type="text"
											aria-describedby="inputGroupPrepend"
											name="adressedest"
											value={values.adressedest || ""}
											onChange={handleChange}
										/>
										<Form.Label className="required">Code Postal :</Form.Label>
										<Form.Control
											required
											type="text"
											aria-describedby="inputGroupPrepend"
											name="codepostaldest"
											value={values.codepostaldest || ""}
											onChange={handleChange}
										/>
										<Form.Label className="required">Ville :</Form.Label>
										<Form.Control
											required
											type="text"
											aria-describedby="inputGroupPrepend"
											name="villedest"
											value={values.villedest || ""}
											onChange={handleChange}
										/>
										<Form.Label className="required">Téléphone :</Form.Label>
										<Form.Control
											required
											type="text"
											aria-describedby="inputGroupPrepend"
											name="telephonedest"
											value={values.telephonedest || ""}
											onChange={handleChange}
										/>

										<Button
											className="my-4"
											size="sm"
											type="submit"
											disabled={isSubmitting}
										>
											Enregistrer
										</Button>
									</Form>
								)}
							</Formik>
						</Col>
					</Row>
				</div>
			</div>
		);
	}
}

export default withRouter(ModifyAdresse);
